/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import produce from "immer";
import {
  CREATE_WAYBILL_REQUEST,
  CREATE_WAYBILL_REQUEST_SUCCESS,
  CREATE_WAYBILL_REQUEST_FAILURE,
  GET_WAYBILL_REQUEST,
  GET_WAYBILL_SUCCESS,
  GET_WAYBILL_FAILURE,
  GET_WAYBILL_BY_ID_REQUEST,
  GET_WAYBILL_BY_ID_SUCCESS,
  GET_WAYBILL_BY_ID_FAILURE,
  UPDATE_COD_WAYBILL_REQUEST,
  UPDATE_COD_WAYBILL_SUCCESS,
  UPDATE_COD_WAYBILL_FAILURE,
  UPDATE_WAYBILL_REQUEST,
  UPDATE_WAYBILL_SUCCESS,
  UPDATE_WAYBILL_FAILURE
} from "src/actions/waybillAction";

const initialState = {
  requestWaybill: [],
  detail: {},
  updateStatus: "",
  totalWaybill: 0,
  loading: false
};

const waybillReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_WAYBILL_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_WAYBILL_REQUEST_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.requestWaybill = draft.requestWaybill.concat(response);
        draft.loading = false;
      });
    }

    case CREATE_WAYBILL_REQUEST_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_WAYBILL_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_WAYBILL_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.requestWaybill = response.data;
        draft.totalWaybill = response.total_items;
        draft.loading = false;
      });
    }

    case GET_WAYBILL_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // Case Get One waybill
    case GET_WAYBILL_BY_ID_REQUEST: {
      return produce(state, (draft) => {
        draft.detail = {};
        draft.loadingGetOneWaybill = true;
      });
    }

    case GET_WAYBILL_BY_ID_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.detail = response;
        draft.loadingGetOneWaybill = false;
      });
    }

    case GET_WAYBILL_BY_ID_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOneWaybill = false;
      });
    }

    // Case Cod Waybill
    case UPDATE_COD_WAYBILL_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateWaybill = true;
      });
    }

    case UPDATE_COD_WAYBILL_SUCCESS: {
      //   const res = action.payload.response;
      //   let updateWaybillList = [...state.requestWaybill];
      //   const idx = updateWaybillList.findIndex((element) => element.id === res.id);

      //   if (idx > -1) {
      //     updateWaybillList[idx] = {
      //       ...updateWaybillList[idx],
      //       cash_on_delivery: res.cashOnDelivery,
      //     };

      //     return produce(state, (draft) => {
      //       draft.requestWaybill = updateWaybillList;
      //       draft.loadingUpdateWaybill = false;
      //     });
      //   }
      return produce(state, (draft) => {
        draft.loadingUpdateWaybill = false;
      });
    }

    case UPDATE_COD_WAYBILL_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateWaybill = false;
      });
    }

    // Case Update One Waybill
    case UPDATE_WAYBILL_REQUEST: {
      return produce(state, (draft) => {
        draft.updateStatus = "UPDATE_WAYBILL_REQUEST";
        draft.loadingUpdateWaybill = true;
      });
    }

    case UPDATE_WAYBILL_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.detail = response;
        draft.updateStatus = "UPDATE_WAYBILL_SUCCESS";
        draft.loadingUpdateWaybill = false;
      });
    }

    case UPDATE_WAYBILL_FAILURE: {
      return produce(state, (draft) => {
        draft.updateStatus = "UPDATE_WAYBILL_FAILURE";
        draft.loadingUpdateWaybill = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default waybillReducer;
